import apiClient from "../apiClient";
import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { formatMoney } from "../formatMoney";
import PageContext from "../PageContext.jsx";

const PeriodsAdd = () => {
    const [period, setPeriod] = useState({
        Description: "",
        DateStart: "",
        DateEnd: "",
        SavingsAmount: "",
        IncomeAmount: "",
        ExpensesAmount: "",
        SavingsIncomeAmount: "",
        LiabilitiesAmount: "",
        Notes: "",
        ActiveYesNo: "0",
        });

    const [error, setError] = useState(false)
    const [currencies, setCurrencies] = useState([]);

    const navigate = useNavigate();
    const defaultCurrency = useMemo(
      () => currencies.find((row) => Number(row.IsDefault))?.Description || "",
      [currencies]
    );

    useEffect(() => {
      const fetchCurrencies = async () => {
        try {
          const res = await apiClient.get("/currencies");
          setCurrencies(Array.isArray(res.data) ? res.data : []);
        } catch {
          setCurrencies([]);
        }
      };
      fetchCurrencies();
    }, []);

    const handleChange = (e) => {
        setPeriod((prev) => ({ ...prev, [e.target.name]: e.target.value }));
        }

    const handleClick = async(e) => {
        e.preventDefault();
        if (!period.Description?.trim() || !period.DateStart || !period.DateEnd) return setError(true);
        try {
            await apiClient.post("/periods", period);
            navigate("/Periods");
        } catch (err) {
            console.log(err);
            setError(true)
        }
     };
    
    return (
        <div className="page">
            <header className="page-header">
                <div>
                    <h1 className="page-title">Add Period</h1>
                    <p className="page-subtitle"><Link to="/">Home</Link> / <Link to="/Periods">Periods</Link> / Add</p>
                </div>
            </header>
            <PageContext
                items={[
                    { label: "Home", to: "/" },
                    { label: "Periods", to: "/Periods" },
                    { label: "Add Period" },
                ]}
                note="Create a reporting period and optionally enter historical income, expense, and savings totals."
            />
            <section className="panel form-card">
                <div className="form">
                    <label htmlFor="period-description">Description</label>
                    <input id="period-description" type="text" placeholder="Period Description" name="Description" value={period.Description} onChange={handleChange} />
                    <label htmlFor="period-start">Start Date</label>
                    <input id="period-start" type="date" name="DateStart" value={period.DateStart} onChange={handleChange} />
                    <label htmlFor="period-end">End Date</label>
                    <input id="period-end" type="date" name="DateEnd" value={period.DateEnd} onChange={handleChange} />
                    <label htmlFor="period-income">Income</label>
                    <input id="period-income" type="number" step="0.01" name="IncomeAmount" value={period.IncomeAmount} onChange={handleChange} />
                    <div className="form-value-preview">Display: {formatMoney(period.IncomeAmount || 0, defaultCurrency || "Default")}</div>
                    <label htmlFor="period-expenses">Expenses</label>
                    <input id="period-expenses" type="number" step="0.01" name="ExpensesAmount" value={period.ExpensesAmount} onChange={handleChange} />
                    <div className="form-value-preview">Display: {formatMoney(period.ExpensesAmount || 0, defaultCurrency || "Default")}</div>
                    <label htmlFor="period-savings">Savings</label>
                    <input id="period-savings" type="number" step="0.01" name="SavingsAmount" value={period.SavingsAmount} onChange={handleChange} />
                    <div className="form-value-preview">Display: {formatMoney(period.SavingsAmount || 0, defaultCurrency || "Default")}</div>
                    <label htmlFor="period-savings-income">Savings Income</label>
                    <input id="period-savings-income" type="number" step="0.01" name="SavingsIncomeAmount" value={period.SavingsIncomeAmount} onChange={handleChange} />
                    <div className="form-value-preview">Display: {formatMoney(period.SavingsIncomeAmount || 0, defaultCurrency || "Default")}</div>
                    <label htmlFor="period-liabilities">Liabilities</label>
                    <input id="period-liabilities" type="number" step="0.01" name="LiabilitiesAmount" value={period.LiabilitiesAmount} onChange={handleChange} />
                    <div className="form-value-preview">Display: {formatMoney(period.LiabilitiesAmount || 0, defaultCurrency || "Default")}</div>
                    <label htmlFor="period-notes">Notes</label>
                    <textarea
                        id="period-notes"
                        name="Notes"
                        rows="3"
                        value={period.Notes}
                        onChange={handleChange}
                        placeholder="Optional notes for this period"
                    />
                    <label htmlFor="period-active">Active</label>
                    <select id="period-active" name="ActiveYesNo" onChange={handleChange} value={period.ActiveYesNo}>
                        <option value="0">No</option>
                        <option value="1">Yes</option>
                    </select>
                    <div className="form-actions">
                        <button className="btn" onClick={handleClick}>Add Period</button>
                        <Link className="btn-link" to="/Periods">Cancel</Link>
                    </div>
                    {error && <p className="notice notice-error">Could not save period. Check input and try again.</p>}
                </div>
            </section>
        </div>
         );
    };

export default PeriodsAdd;
